var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-panel',{attrs:{"title":"Statistics","edit-mode":_vm.editMode,"popout-url":"/app/stats.html","popout-width":760,"popout-height":480},on:{"remove":function($event){return _vm.$emit('remove')}}},[_c('stats-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }